import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CustomService } from '@/shared/services/custom.service';
import { SituacaoMilitarResponse } from './documentos.model';

@Injectable({
    providedIn: 'root'
})
/** Service de apoio aos documentos do médico (domínios/situações militares). */
export class DocumentosService extends CustomService {
    private readonly apiUrlSituacoesMilitares = environment.apis.apiSicom + '/api/v1/cadastro/medico/situacoes-militares';

    private readonly http = inject(HttpClient);

    /**
     * Lista as Situações Militares.
     * GET /api/v1/cadastro/medico/situacoes-militares
     */
    listarSituacoesMilitares(): Observable<SituacaoMilitarResponse[]> {
        return this.http.get<SituacaoMilitarResponse[]>(this.apiUrlSituacoesMilitares).pipe(catchError(this.handleError));
    }
}
